import { Outlet } from "react-router";

const DayClosingIndexpage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default DayClosingIndexpage;
